import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PaymentService = {
 
  payWithCard: async (data, orgCode) => {
    try {
      const response = await apiService.post(
        `/card-payment/payment`,
        data,
         {
      headers: {
        APIKEY: orgCode, 
      },
    }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  daybookList: async (fromDate, toDate) => {
    const response = await apiService.get(
      `/paymenttransactionlogs/daybook?fromDate=${fromDate}&toDate=${toDate}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  update: async (id, data) => {
    try {
      const response = await apiService.put(
        `/paymenttransactionlogs/report/${id}`,
        data,
        {
          headers: {
            authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/paymenttransactionlogs/report/${id}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  dayBookLog: async (fromDate, toDate) => {
    const response = await apiService.get(
      `/daybooklogs/list?fromDate=${fromDate}&toDate=${toDate}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  dayBookLogDetail: async (id) => {
    const response = await apiService.get(`/daybooklogs/${id}`, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
};

export default PaymentService;
